import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPersist from "pinia-plugin-persist";

import App from "./App.vue";
import router from "./router";
import VueApexCharts from "vue3-apexcharts";
import vClickOutside from "click-outside-vue3";
import { registerScrollSpy } from "vue3-scroll-spy";

// import Maska from 'maska'
import i18n from "./i18n";
import { initFirebaseBackend } from "./authUtils";
//import { configureFakeBackend } from './helpers/fake-backend';

import BootstrapVueNext from "bootstrap-vue-next";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";

// ADDED: Import axios configuration for global error handling
import "./plugins/axios";

// ADDED: Import auth migration utility
import { migrateAuthData, clearAllAuthData } from "./utils/authMigration";

const firebaseConfig = {
  apiKey: process.env.VUE_APP_APIKEY,
  authDomain: process.env.VUE_APP_AUTHDOMAIN,
  databaseURL: process.env.VUE_APP_VUE_APP_DATABASEURL,
  projectId: process.env.VUE_APP_PROJECTId,
  storageBucket: process.env.VUE_APP_STORAGEBUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
  appId: process.env.VUE_APP_APPId,
  measurementId: process.env.VUE_APP_MEASUREMENTID,
};

if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
  initFirebaseBackend(firebaseConfig);
} else {
  //configureFakeBackend();
}

import "sweetalert2/dist/sweetalert2.min.css";
import "@vueform/slider/themes/default.css";

import store from "./state/store";

import "../src/design/app.scss";

// Create the app
const app = createApp(App);

// ENHANCED: Global error handler for uncaught errors
app.config.errorHandler = (err) => {
  // Handle specific error types
  if (err.name === "AxiosError") {
    console.error("🔥 Unhandled Axios Error:", {
      message: err.message,
      status: err.response?.status,
      url: err.config?.url,
      method: err.config?.method,
    });

    // If it's a 401 that wasn't caught by interceptor
    if (err.response?.status === 401) {
      // Clear auth data (both old and new formats)
      clearAllAuthData();

      // Redirect to login
      window.location.href = "/login";
    }
  }

  // Log to external service in production
  if (process.env.NODE_ENV === "production") {
    // Example: Send to error tracking service
    // Sentry.captureException(err);
    console.error("Production error:", err);
  }
};

// ADDED: Global warning handler
app.config.warnHandler = (msg, instance, trace) => {
  console.warn("⚠️ GGGGlobal Warning Handler:", msg, trace);
};

// ADDED: Global unhandled promise rejection handler
window.addEventListener("unhandledrejection", (event) => {
  console.error("🔥 Unhandled Promise Rejection:", event.reason);

  // Handle axios errors that might not be caught
  if (
    event.reason?.name === "AxiosError" &&
    event.reason?.response?.status === 401
  ) {
    console.warn("🔐 Unhandled 401 promise rejection - forcing logout");

    clearAllAuthData();

    window.location.href = "/login";
  }

  // Prevent the default unhandled rejection behavior
  event.preventDefault();
});

// Run auth data migration before starting the app
migrateAuthData();

const pinia = createPinia();
pinia.use(piniaPersist);

app
  .use(store)
  .use(router)
  .use(require("vue-chartist"))
  .use(BootstrapVueNext)
  .use(VueApexCharts)
  .use(vClickOutside)
  .use(i18n)
  .use(registerScrollSpy)
  // .use(Maska)
  .use(pinia)
  .mount("#app");
